import { registerRequestWatcher } from './containers/RegisterCustomer/saga.es6'
import {
  loginRequestWatcher,
  refreshSessionRequestWatcher,
  forgotPasswordRequestWatcher,
  logoutRequestWatcher,
  getStartedMessageRequestWatcher,
  otpVerifyRequestWatcher,
  otpResendRequestWatcher
} from './containers/Login/saga.es6'
import {
  purchasePolicyRequestWatcher,
  productListWatcher
} from './containers/BuyPolicy/saga.es6'
import { searchCustomerByMsisdnRequestWatcher } from './containers/Search/saga.es6'
import {
  claimSubmissionWatcher,
  claimTypesWatcher
} from './containers/ClaimSubmission/saga.es6'
import {
  deletePolicyWatcher,
  getPolicyProductWatcher,
  initiatePolicyMobilePaymentWatcher
} from './containers/PolicyList/saga.es6'
import {
  getCustomerRequestWatcher,
  updateCustomerRequestWatcher,
  updatePolicyRequestWatcher,
  changeLoyaltyRegistrationWatcher,
  pullCustomerKycWatcher
} from './containers/Customer/saga.es6'
import {
  profileRequestWatcher,
  profileUpdateRequestWatcher
} from './containers/Profile/saga.es6'
import { openClaimRequestWatcher } from './containers/ClaimsOpen/saga.es6'
import { claimStatusRequestWatcher } from './containers/ClaimsStatus/saga.es6'
import { payableClaimRequestWatcher } from './containers/ClaimsPayable/saga.es6'
import { closedClaimRequestWatcher } from './containers/ClaimsClosed/saga.es6'
import { summaryClaimRequestWatcher } from './containers/ClaimsDashboard/saga.es6'
import {
  claimConditionListWatcher,
  claimFileDeleteRequestWatcher,
  claimHospitalsWatcher,
  claimProcessingWatcher,
  claimRejectionReasonWatcher,
  claimUploadRequestWatcher,
  refreshClaimRequestWatcher,
  retryFailedClaimPaymentRequestWatcher,
  updateClaimPaymentOutcomeRequestWatcher,
  expiredClaimReversalWatcher,
  claimCreateRequestWatcher
} from './containers/ClaimsProcessing/saga.es6'
// import { claimSearchRequestWatcher } from "./containers/ClaimSearch/saga.es6";
import {
  AddMissingPaymentRequestWatcher,
  deletePremiumWatcher,
  sendRecurringPaymentRecommendationSmsRequestWatcher
} from './containers/CustomerStatus/saga.es6'
import {
  claimCallbackDeleteRequestWatcher,
  claimCallbackRequestWatcher,
  getClosedClaimCallbackRequestWatcher
} from './containers/ClaimCallback/saga.es6'
import {
  createCountryRequestWatcherSaga,
  getCountriesRequestWatcherSaga,
  deleteCountryRequestWatcherSaga,
  updateCountryRequestWatcherSaga
} from './containers/Country/saga.es6'
import {
  changeUserPasswordRequestWatcher,
  createUserRequestWatcher,
  deleteUserRequestWatcher,
  getPartnersRequestWatcher,
  getRolesRequestWatcher,
  getCurrentRolesRequestWatcher,
  getCurrentPartnersRequestWatcher,
  getUsersRequestWatcher,
  getAgentsRequestWatcher,
  updateRolesAndPartnersRequestWatcher,
  resetPasswordRequestWatcher,
  getUserRequestWatcher,
  disableUserRequestWatcher,
  getDisabledUsersRequestWatcher,
  getUserAuthActivitiesRequestWatcher,
  getAllUsersAuthActivitiesRequestWatcher,
  enableUserRequestWatcher
} from './containers/Users/saga.es6'
import {
  downloadBulkSmsRequestWatcher,
  summariseBulkSmsRequestWatcher,
  uploadBulkSmsRequestWatcher,
  stopBlastRequestWatcher,
  getBatchProgressRequestWatcher
} from './containers/BulkSms/saga.es6'
import {
  getAllPartnersRequestWatcher,
  createPartnerRequestWatcher,
  getPartnerRequestWatcher
} from './containers/Partners/saga.es6'

import { getLanguagesWatcher } from './containers/Languages/saga.es6'

import {
  getAllProductsRequestWatcher,
  createProductRequestWatcher,
  getProductRequestWatcher,
  getProductEnumRequestWatcher
} from './containers/ProductList/saga.es6'

import {
  createProductPackageRequestWatcher,
  getProductPackagesRequestWatcher,
  updateProductPackageRequestWatcher,
  deleteProductPackageRequestWatcher,
  getProductPackageBenefitsRequestWatcher,
  createProductPackageBenefitRequestWatcher,
  createBenefitRatingChainRequestWatcher,
  updateBenefitRatingChainRequestWatcher,
  updateProductPackageBenefitRequestWatcher,
  deleteProductPackageBenefitRequestWatcher,
  getProductAddonsRequestWatcher,
  updateProductAddonRequestWatcher,
  deleteProductAddonRequestWatcher,
  createProductAddonRequestWatcher,
  getCashbackConfigRequestWatcher,
  createCashbackConfigRequestWatcher,
  updateCashbackConfigRequestWatcher,
  deleteCashbackConfigRequestWatcher,
  createAgeValidationRuleRequestWatcher,
  updateAgeValidationRuleRequestWatcher,
  deleteAgeValidationRuleRequestWatcher,
  getAgeValidationRulesRequestWatcher,
  deleteProductAutoRenewalConfigRequestWatcher,
  updateProductAutoRenewalConfigRequestWatcher,
  createProductAutoRenewalConfigRequestWatcher,
  getProductAutoRenewalConfigRequestWatcher,
  uploadDocumentRequestWatcher,
  pollDraftJobRequestWatcher,
  fetchPartnerDraftsRequestWatcher,
  reviewDraftRequestWatcher,
  importDraftProductRequestWatcher,
  evaluateProductQuoteRequestWatcher,
  compareQuotationsRequestWatcher,
  getProductRatingNodesRequestWatcher,
  createProductRatingNodeRequestWatcher,
  updateProductRatingNodeRequestWatcher,
  deleteProductRatingNodeRequestWatcher,
  getRatingTablesRequestWatcher,
  ratingTableActionRequestWatcher,
  saveRatingTableRequestWatcher,
  downloadRatingTemplateRequestWatcher,
  validateRatingWorkbookRequestWatcher,
  importRatingWorkbookRequestWatcher,
  getRatingSnapshotsRequestWatcher,
  getChangeRequestsRequestWatcher,
  resolveChangeRequestRequestWatcher
} from './containers/GenericProductConfig/saga.es6.js'

import {
  createPremiumRequestWatcher,
  hardDeletePremiumRequestWatcher,
  createBenefitRequestWatcher,
  hardDeleteBenefitRequestWatcher,
  editProductRequestWatcher,
  editPremiumRequestWatcher,
  editBenefitRequestWatcher,
  getGroupProductConfigsRequestWatcher,
  updateGroupProductConfigsRequestWatcher,
  addGroupProductConfigsRequestWatcher,
  getExtendedFamilyProductConfigsRequestWatcher,
  updateExtendedFamilyProductConfigsRequestWatcher,
  addExtendedFamilyProductConfigsRequestWatcher,
  createPremiumConfigRequestWatcher,
  getPremiumConfigsRequestWatcher,
  createAddonConfigRequestWatcher
} from './containers/NewProductList/saga.es6'

import {
  createProductPremiumRequestWatcher,
  getAllProductPremiumsRequestWatcher,
  getProductPremiumsEnumRequestWatcher
} from './containers/ProductPremiums/saga.es6'
import {
  addMultiplePaymentRequestWatcher,
  addSinglePaymentRequestWatcher
} from './containers/ManualPayment/saga.es6'

import {
  getSmsTemplatesRequestWatcher,
  createSmsTemplatesRequestWatcher,
  updateSmsTemplatesRequestWatcher,
  deleteSmsTemplatesRequestWatcher,
  getSupportedParametersRequestWatcher
} from './containers/SmsTemplate/saga.es6'

import {
  getEngineFlowsWatcher,
  getEngineFlowRawWatcher,
  publishEngineFlowWatcher,
  createEngineFlowWatcher
} from './containers/EngineFlows/saga.es6'

import {
  getUssdFlowsWatcher,
  getUssdSessionsWatcher,
  getUssdMessagesWatcher,
  simulateStartWatcher,
  simulateResumeWatcher
} from './partner-apps/OldMutualMalawi/UssdSessions/Redux/saga'

import {
  getTaxConfigsWatcher,
  getTaxConfigRawWatcher,
  publishTaxConfigWatcher,
  createTaxConfigWatcher
} from './containers/TaxConfigs/saga.es6'

import {
  getEngineConfigsWatcher,
  getEngineConfigRawWatcher,
  publishEngineConfigWatcher,
  createEngineConfigWatcher
} from './containers/EngineConfigs/saga.es6'

import {
  getAmlConfigsWatcher,
  getAmlConfigRawWatcher,
  publishAmlConfigWatcher,
  createAmlConfigWatcher
} from './containers/AmlConfigs/saga.es6'

import {
  getRiskConfigsWatcher,
  getRiskConfigRawWatcher,
  publishRiskConfigWatcher,
  createRiskConfigWatcher
} from './containers/RiskConfigs/saga.es6'

import {
  getIprsConfigsWatcher,
  getIprsConfigRawWatcher,
  publishIprsConfigWatcher,
  createIprsConfigWatcher
} from './containers/IprsConfigs/saga.es6'

import {
  getGatewayConfigsWatcher,
  getGatewayConfigRawWatcher,
  publishGatewayConfigWatcher,
  createGatewayConfigWatcher
} from './containers/GatewayConfigs/saga.es6'

import { addRemittancesRequestWatcher } from './containers/ManualRemittance/saga.es6'
import {
  cashBackRequestWatcher,
  markAsPaidRequestWatcher,
  markAsUnpaidRequestWatcher
} from './containers/Cashback/saga.es6'
import {
  uploadLoyaltyDataRequestWatcher,
  mapColumnsToFieldsRequestWatcher,
  getPreviousLoyaltyStatusRequestWatcher,
  getPreviousLoyaltiesStatusRequestWatcher
} from './containers/LoyaltyEligibility/saga.es6'

import {
  getPartnerConfigsClaimRequestWatcher,
  getPartnerConfigsGroupRequestWatcher,
  getPartnerConfigsRequestWatcher,
  getPartnerEmailConfigsRequestWatcher,
  getEmailClientsWatcher,
  updatePartnerConfigGroupRequestWatcher,
  updatePartnerConfigClaimRequestWatcher,
  updatePartnerConfigRequestWatcher,
  updatePartnerConfigEmailRequestWatcher,
  updatePartnerRequestWatcher,
  getPartnerSmsChannelsWatcher,
  saveSmsChannelWatcher,
  deleteSmsChannelWatcher,
  testSmsChannelWatcher,
  saveChannelResolutionWatcher,
  getPolicyMakerChecksWatcher,
  savePolicyMakerCheckWatcher,
  deletePolicyMakerCheckWatcher
} from './containers/PartnerStatus/saga.es6'
import {
  addCustomerDependantRequestWatcher,
  deleteCustomerDependantRequestWatcher,
  getCustomerDependantRequestWatcher,
  getCustomerDependantsRequestWatcher,
  updateCustomerDependantRequestWatcher
} from './containers/DependantsList/saga.es6'
import {
  addCustomerDocumentRequestWatcher,
  deleteCustomerDocumentRequestWatcher,
  getCustomerDocumentRequestWatcher,
  getCustomerDocumentsRequestWatcher,
  updateCustomerDocumentRequestWatcher
} from './containers/CustomerFiles/saga.es6'
import {
  createDebitOrderzRequestWatcher,
  editDebitOrderzRequestWatcher,
  getBanksWatcher,
  getDebitOrderzRequestWatcher,
  hardDeleteDebitOrderzRequestWatcher
} from './containers/CustomerScreen/components/DebitOrder/state/saga.es6'
import {
  getAllCustomerClaimsWatcher,
  getAllPaymentsWatcher,
  getAllPoliciesWatcher,
  getAllPremiumsWatcher,
  getAllProductsWatcher,
  getTotalPayablePremiumWatcher,
  getAllMandatesWatcher
} from './containers/CustomerScreen/saga.es6'

import {
  getCustomeBeneficiaryRequestWatcher,
  addCustomerBeneficiaryRequestWatcher,
  updateCustomerBeneficiaryRequestWatcher,
  deleteCustomerBeneficiaryRequestWatcher
} from './containers/BeneficiaryList/saga.js'

import {
  getCustomeBeneficiaryBankDetailsRequestWatcher,
  addCustomerBeneficiaryBankDetailsRequestWatcher,
  updateCustomerBeneficiaryBankDetailsRequestWatcher,
  deleteCustomerBeneficiaryBankDetailsRequestWatcher
} from './containers/BeneficiaryBankDetailsList/saga.js'

import {
  getCustomerBankDetailsRequestWatcher,
  updateCustomerBankDetailsRequestWatcher,
  addCustomerBankDetailsRequestWatcher,
  deleteCustomerBankDetailsRequestWatcher
} from './containers/CustomerBankDetailsList/saga.js'
import {
  createQuoteRequestWatcher,
  BuyPolicyRequestWatcher,
  changeQuoteRequestWatcher,
  UploadPolicyDocumentRequestWatcher,
  createDebitOrdersDcpRequestWatcher,
  amendQuoteRequestWatcher
} from './containers/Policyv2/Redux/saga.js'

import {
  getCustomerPoliciesRequestWatcher,
  getCustomerQuotesRequestWatcher,
  getCustomerPremiumsComplexRequestWatcher,
  cancelPolicyRequestWatcher,
  PolicyNotesRequestWatcher,
  PolicyNotesAddRequestWatcher
} from './containers/PolicyV2CustomerStatus/Redux/saga.js'

import {
  selectPolicyRequestWatcher,
  initiateClaimDcpRequestWatcher,
  getCustomerClaimsDcpRequestWatcher
} from './containers/ClaimInitiationv2/Redux/saga.js'
import { getClaimsDcpRequestWatcher } from './containers/ClaimDashboardv2/Redux/saga.js'
import {
  getPreauthDetailsRequestWatcher,
  createExpenseRequestWatcher,
  deleteExpenseRequestWatcher,
  editExpenseRequestWatcher,
  addClaimDocumentRequestWatcher,
  deleteClaimDocumentRequestWatcher,
  claimActionsRequestWatcher,
  claimNotesRequestWatcher,
  getClaimProcessingDcpRequestWatcher,
  saveClaimDcpDocumentRequestWatcher,
  claimFacilityNotesRequestWatcher,
  createClaimNotesRequestWatcher,
  deleteClaimNotesRequestWatcher,
  updateClaimNotesRequestWatcher
} from './containers/ClaimsProcessingV2/Redux/saga'
import {
  addTemplateDocumentRequestWatcher,
  deleteTemplateDocumentRequestWatcher,
  downloadDocumentRequestWatcher,
  emailDocumentRequestWatcher,
  editTemplateDocumentRequestWatcher,
  getTemplateDocumentRequestWatcher
} from './containers/DocumentGeneration/saga.es6'
import {
  createLOURequestWatcher,
  editLOURequestWatcher,
  getLOUSRequestWatcher,
  createHospitalRequestWatcher,
  deleteHospitalRequestWatcher,
  getHospitalsRequestWatcher,
  searchHospitalsRequestWatcher,
  createDiagnosisRequestWatcher,
  deleteDiagnosisRequestWatcher,
  getDiagnosisRequestWatcher,
  searchDiagnosisRequestWatcher,
  deleteLouRequestWatcher
} from './partner-apps/ktda/PreAuth/Redux/saga.js'
import {
  bulkApproveRequestWatcher,
  getClaimsDcpFilteredRequestWatcher
} from './partner-apps/ktda/ClaimDashboard/Redux/saga.js'
import {
  addBulkPolicyOnboardingRequestWatcher,
  saveBulkPolicyOnboardingRequestWatcher,
  getBulkPoliciesOnboardingBatchesRequestWatcher,
  getFailedBulkPoliciesBatchesRequestWatcher
} from './partner-apps/ktda/BulkPolicyOnboarding/Redux/saga.js'
import {
  addBulkPaymentsRequestWatcher,
  getBulkPaymentsBatchesRequestWatcher,
  getFailedBulkPaymentsBatchesRequestWatcher,
  saveBulkPaymentsRequestWatcher
} from './partner-apps/ktda/BulkPayments/Redux/saga'

import { getFeatureFlagsRequestWatcher } from './containers/FeatureFlags/saga.es6.js'
import {
  getLookupListTypesRequestWatcher,
  getLookupListRequestWatcher,
  addLookupListItemRequestWatcher,
  updateLookupListItemRequestWatcher,
  deleteLookupListItemRequestWatcher
} from './containers/CoverLinkSettings/saga.es6.js'
import {
  registerAccessBankRequestWatcher,
  updateAccessBankCustomerRequestWatcher
} from './partner-apps/AccessBank/CustomerStatus/Containers/RegisterCustomer/redux/saga.js'
import { getPoliciesDcpRequestWatcher } from './partner-apps/AccessBank/PoliciesDashboard/Redux/saga.js'
import {
  getPolicyCancellationRequestsWatcher,
  updatePolicyCancellationWatcher
} from './partner-apps/Samba/PolicyCancellation/Redux/saga.js'
import {
  getPolicyProcessingDcpRequestWatcher,
  getPolicyProcessingCustomerQuotesRequestWatcher,
  policyActionsRequestWatcher,
  policyRejectActionsRequestWatcher,
  makerCheckDecisionRequestWatcher,
  returnToPriorStageRequestWatcher,
  setNeedActionRequestWatcher,
  quotationDecisionRequestWatcher,
  addPolicyNotesAddRequestWatcher,
  cancelPolicyActionRequestWatcher,
  deleteCustomerPolicyDocumentRequestWatcher,
  getPaymentsByPolicyGuidRequestWatcher,
  initiatePaymentWatcher,
  generatePolicyCheckoutLinkWatcher,
  findCustomerForTransferRequestWatcher,
  switchPolicyCustomerRequestWatcher
} from './partner-apps/AccessBank/PoliciesProcessing/Redux/saga.js'
import { getPaymentsDcpRequestWatcher } from './partner-apps/AccessBank/PaymentsDashboard/Redux/saga.js'
import {
  getPaymentProcessingDcpRequestWatcher,
  paymentApproveActionRequestWatcher,
  paymentRejectActionsRequestWatcher
} from './partner-apps/AccessBank/PaymentProcessing/Redux/saga.js'
import { getAccessBankCustomerQuotesRequestWatcher } from './partner-apps/AccessBank/CustomerStatus/Containers/Quotes/Redux/saga.js'
import {
  getAccessBankCustomerPremiumsRequestWatcher,
  removeComplexPremiumRequestWatcher
} from './partner-apps/AccessBank/CustomerStatus/Containers/Premiums/Redux/saga.js'
import { getCustomerAccessBankClaimsRequestWatcher } from './partner-apps/AccessBank/CustomerStatus/Containers/Claims/redux/saga.js'
import { getAccessBankSmsActivitiesRequestWatcher } from './partner-apps/AccessBank/CustomerStatus/Containers/SmsActivity/Redux/saga.js'
import {
  getEmailTemplatesRequestWatcher,
  addEmailTemplateRequestWatcher,
  updateEmailTemplateRequestWatcher,
  deleteEmailTemplateRequestWatcher
} from './containers/EmailTemplates/Redux/saga.js'
import {
  addReportTemplateRequestWatcher,
  getReportsTemplatesRequestWatcher,
  editReportTemplateRequestWatcher,
  deleteReportTemplateRequestWatcher
} from './containers/ReportsConfigs/Redux/saga.js'
import { generateReportRequestWatcher } from './containers/Reports/Redux/saga.js'
import {
  addGuideRequestWatcher,
  deleteGuideRequestWatcher,
  editGuideRequestWatcher,
  getGuideRequestWatcher,
  getGuidesRequestWatcher
} from './components/KnowledgeBase/Redux/saga.js'
import { getElasticSearchResultsRequestWatcher } from './containers/ElasticSearch/Redux/saga.js'
import { NGSGroupCustomerQuotesRequestWatcher } from './partner-apps/NgsUganda/CustomerStatus/Container/Quotes/Redux/saga.js'
import { getNgsCustomerClaimsRequestWatcher } from './partner-apps/NgsUganda/CustomerStatus/Container/Claims/redux/saga.js'
import { getAuditsRequestWatcher } from './containers/Audits/Redux/saga.js'
import {
  getEmailTemplateByGuidRequestWatcher,
  sendEmailRequestWatcher
} from './partner-apps/InclMotor/PolicyAdmin/Redux/saga.js'
import {
  registerDcpRequestWatcher,
  updateDcpCustomerRequestWatcher
} from './partner-apps/MalipoWws/CustomerStatus/Containers/RegisterCustomer/redux/saga.js'

import {
  assignLawyerRequestWatcher,
  markInvoiceAsPaidRequestWatcher
} from './partner-apps/CoverLink/ClaimProcessing/Redux/saga.js'
import { getRecentPoliciesRequestWatcher } from './components/RecentPolicies/Redux/saga.js'
import { getRecentPaymentsRequestWatcher } from './components/RecentPayments/Redux/saga.js'
import { getPolicyByGuidRequestWatcher } from './partner-apps/Mzanu/ClaimsProcessing/Redux/saga.js'
import {
  getAllWebhookSubscriptionsRequestWatcher,
  createWebhookSubscriptionRequestWatcher,
  editWebhookSubscriptionRequestWatcher,
  deleteWebhookSubscriptionRequestWatcher,
  saveWebhookSubscriptionAuthRequestWatcher,
  deleteWebhookSubscriptionAuthRequestWatcher
} from './containers/WebhookSubscriptions/saga.es6'
import {
  getOrganizationsRequestWatcher,
  getOrganizationRequestWatcher,
  createOrganizationRequestWatcher,
  updateOrganizationRequestWatcher,
  deleteOrganizationRequestWatcher
} from './containers/Organizations/Redux/saga.js'
import {
  getOrgProductTemplatesRequestWatcher,
  createOrgProductTemplateRequestWatcher,
  updateOrgProductTemplateRequestWatcher,
  deleteOrgProductTemplateRequestWatcher
} from './containers/OrganizationProductTemplates/Redux/saga.js'
import {
  getOrgEmailTemplatesRequestWatcher,
  createOrgEmailTemplateRequestWatcher,
  updateOrgEmailTemplateRequestWatcher,
  deleteOrgEmailTemplateRequestWatcher
} from './containers/OrganizationEmailTemplates/Redux/saga.js'
import {
  getOrgSmsTemplatesRequestWatcher,
  createOrgSmsTemplateRequestWatcher,
  updateOrgSmsTemplateRequestWatcher,
  deleteOrgSmsTemplateRequestWatcher
} from './containers/OrganizationSmsTemplates/Redux/saga.js'
import {
  getOrgWebhookTemplatesRequestWatcher,
  createOrgWebhookTemplateRequestWatcher,
  updateOrgWebhookTemplateRequestWatcher,
  deleteOrgWebhookTemplateRequestWatcher
} from './containers/OrganizationWebhookTemplates/Redux/saga.js'
import {
  loadOrgConfigOnPartnerSwitchWatcher,
  loadOrgConfigRequestWatcher
} from './containers/OrgConfig/Redux/saga.js'
import {
  getOrgIppConfigsRequestWatcher,
  createOrgIppConfigRequestWatcher,
  updateOrgIppConfigRequestWatcher,
  deleteOrgIppConfigRequestWatcher
} from './containers/OrganizationIppConfigs/Redux/saga.js'
import {
  getOrgClaimInitConfigsRequestWatcher,
  createOrgClaimInitConfigRequestWatcher,
  updateOrgClaimInitConfigRequestWatcher,
  deleteOrgClaimInitConfigRequestWatcher
} from './containers/OrganizationClaimInitiation/Redux/saga.js'
import {
  getOrgCustomerStatusConfigsRequestWatcher,
  createOrgCustomerStatusConfigRequestWatcher,
  updateOrgCustomerStatusConfigRequestWatcher,
  deleteOrgCustomerStatusConfigRequestWatcher
} from './containers/OrganizationCustomerStatus/Redux/saga.js'
import {
  getCommissionAgentsRequestWatcher,
  getCommissionAgentRequestWatcher,
  resolveCommissionAgentsWatcher,
  commissionAgentExistsWatcher,
  lookupCommissionAgentRequestWatcher,
  createCommissionAgentRequestWatcher,
  createAgentWithUserWatcher,
  updateCommissionAgentRequestWatcher,
  deleteCommissionAgentRequestWatcher,
  deleteCommissionAgentPermanentRequestWatcher,
  getUsersForAgentsRequestWatcher,
  getAgentBanksByAgentRequestWatcher,
  createAgentBankRequestWatcher,
  updateAgentBankRequestWatcher,
  deleteAgentBankRequestWatcher,
  deleteAgentBankPermanentRequestWatcher
} from './containers/CommissionAgents/saga.es6'
import {
  getCommissionAgenciesRequestWatcher,
  getCommissionAgencyRequestWatcher,
  createCommissionAgencyRequestWatcher,
  updateCommissionAgencyRequestWatcher
} from './containers/CommissionAgencies/saga.es6'
import {
  getCommissionRulesRequestWatcher,
  getCommissionRuleRequestWatcher,
  createCommissionRuleRequestWatcher,
  updateCommissionRuleRequestWatcher,
  validateCommissionRuleRequestWatcher
} from './containers/CommissionRules/saga.es6'
import {
  getClawbackRulesRequestWatcher,
  getClawbackRuleRequestWatcher,
  createClawbackRuleRequestWatcher,
  updateClawbackRuleRequestWatcher,
  validateClawbackRuleRequestWatcher,
  getClawbackSymbolsRequestWatcher
} from './containers/ClawbackRules/saga.es6'
import {
  getCommissionTransactionsRequestWatcher,
  getPayoutTransactionsRequestWatcher,
  getClawbackTransactionsRequestWatcher,
  getCommissionTxnStatsRequestWatcher,
  getPayoutTxnStatsRequestWatcher,
  getClawbackTxnStatsRequestWatcher,
  getCommissionTransactionByGuidRequestWatcher,
  getCommissionTransactionsByAgentRequestWatcher,
  getPayoutTransactionByGuidRequestWatcher,
  getPayoutTransactionsByAgentRequestWatcher,
  getClawbackTransactionByGuidRequestWatcher,
  getClawbackTransactionsByAgentRequestWatcher,
  getCommissionCalculationLogRequestWatcher
} from './containers/CommissionTransactions/saga.es6'
import { getCommissionStatementRequestWatcher } from './containers/CommissionTransactions/statement/saga.es6'
import {
  getCommissionAccountsRequestWatcher,
  getAgentCommissionAccountRequestWatcher,
  getCommissionAccountByGuidRequestWatcher,
  getAgentCommissionAccountTransactionsRequestWatcher
} from './containers/CommissionAccounts/saga.es6'
import {
  getBatchPayoutsRequestWatcher,
  getBatchPayoutRequestWatcher,
  createBatchPayoutRequestWatcher,
  payBatchPayoutsRequestWatcher,
  confirmBatchPayoutRequestWatcher,
  batchPayoutPollingWatcher,
  getAgencyAgentsRequestWatcher,
  resolveHeldBatchPayoutsWatcher
} from './containers/BatchPayouts/saga.es6'
import {
  getCommissionSettingsRequestWatcher,
  updateCommissionSettingsRequestWatcher
} from './containers/CommissionSettings/saga.es6'
import {
  getOrgClaimProcConfigsRequestWatcher,
  createOrgClaimProcConfigRequestWatcher,
  updateOrgClaimProcConfigRequestWatcher,
  deleteOrgClaimProcConfigRequestWatcher
} from './containers/OrganizationClaimProcessing/Redux/saga.js'
import {
  getOmkGroupsRequestWatcher,
  getOmkGroupRequestWatcher,
  approveOmkGroupRequestWatcher,
  setOmkGroupVerificationRequestWatcher,
  uploadOmkGroupDocumentRequestWatcher,
  deleteOmkGroupDocumentRequestWatcher,
  getOmkGroupPoliciesRequestWatcher,
  approveOmkGroupPoliciesRequestWatcher
} from './partner-apps/OldMutualKenya/GroupApprovalDashboard/Redux/saga'
import {
  getGroupPaymentsRequestWatcher,
  getGroupPaymentRequestWatcher,
  updateGroupPaymentStatusRequestWatcher,
  resolveOmkPaymentLabelsRequestWatcher
} from './partner-apps/OldMutualKenya/GroupPaymentDashboard/Redux/saga'
// single entry point to start all Sagas at once
export default function* rootSaga() {
  yield [
    registerRequestWatcher(),
    loginRequestWatcher(),
    purchasePolicyRequestWatcher(),
    searchCustomerByMsisdnRequestWatcher(),
    claimSubmissionWatcher(),
    deletePolicyWatcher(),
    getCustomerRequestWatcher(),
    claimTypesWatcher(),
    profileRequestWatcher(),
    profileUpdateRequestWatcher(),
    productListWatcher(),
    updateCustomerRequestWatcher(),
    refreshSessionRequestWatcher(),
    openClaimRequestWatcher(),
    payableClaimRequestWatcher(),
    closedClaimRequestWatcher(),
    summaryClaimRequestWatcher(),
    claimStatusRequestWatcher(),
    claimProcessingWatcher(),
    getUsersRequestWatcher(),
    getAgentsRequestWatcher(),
    createUserRequestWatcher(),
    getPartnersRequestWatcher(),
    getRolesRequestWatcher(),
    getCurrentRolesRequestWatcher(),
    getCurrentPartnersRequestWatcher(),
    deleteUserRequestWatcher(),
    disableUserRequestWatcher(),
    changeUserPasswordRequestWatcher(),
    updatePolicyRequestWatcher(),
    changeLoyaltyRegistrationWatcher(),
    pullCustomerKycWatcher(),
    deletePremiumWatcher(),
    claimHospitalsWatcher(),
    claimRejectionReasonWatcher(),
    claimCallbackRequestWatcher(),
    forgotPasswordRequestWatcher(),
    getPolicyProductWatcher(),
    initiatePolicyMobilePaymentWatcher(),
    claimUploadRequestWatcher(),
    claimFileDeleteRequestWatcher(),
    claimCallbackDeleteRequestWatcher(),
    refreshClaimRequestWatcher(),
    retryFailedClaimPaymentRequestWatcher(),
    uploadBulkSmsRequestWatcher(),
    summariseBulkSmsRequestWatcher(),
    downloadBulkSmsRequestWatcher(),
    updateClaimPaymentOutcomeRequestWatcher(),
    AddMissingPaymentRequestWatcher(),
    claimConditionListWatcher(),
    expiredClaimReversalWatcher(),
    updateRolesAndPartnersRequestWatcher(),
    resetPasswordRequestWatcher(),
    createCountryRequestWatcherSaga(),
    getCountriesRequestWatcherSaga(),
    deleteCountryRequestWatcherSaga(),
    updateCountryRequestWatcherSaga(),
    getLanguagesWatcher(),
    getAllPartnersRequestWatcher(),
    createPartnerRequestWatcher(),
    getPartnerRequestWatcher(),
    getAllProductsRequestWatcher(),
    createProductRequestWatcher(),
    getProductRequestWatcher(),
    getProductEnumRequestWatcher(),
    createProductPremiumRequestWatcher(),
    getProductPremiumsEnumRequestWatcher(),
    getAllProductPremiumsRequestWatcher(),
    addMultiplePaymentRequestWatcher(),
    addSinglePaymentRequestWatcher(),
    getSmsTemplatesRequestWatcher(),
    createSmsTemplatesRequestWatcher(),
    updateSmsTemplatesRequestWatcher(),
    deleteSmsTemplatesRequestWatcher(),
    getEngineFlowsWatcher(),
    getEngineFlowRawWatcher(),
    publishEngineFlowWatcher(),
    createEngineFlowWatcher(),
    getUssdFlowsWatcher(),
    getUssdSessionsWatcher(),
    getUssdMessagesWatcher(),
    simulateStartWatcher(),
    simulateResumeWatcher(),
    getTaxConfigsWatcher(),
    getTaxConfigRawWatcher(),
    publishTaxConfigWatcher(),
    createTaxConfigWatcher(),
    getEngineConfigsWatcher(),
    getEngineConfigRawWatcher(),
    publishEngineConfigWatcher(),
    createEngineConfigWatcher(),
    getAmlConfigsWatcher(),
    getAmlConfigRawWatcher(),
    publishAmlConfigWatcher(),
    createAmlConfigWatcher(),
    getRiskConfigsWatcher(),
    getRiskConfigRawWatcher(),
    publishRiskConfigWatcher(),
    createRiskConfigWatcher(),
    getIprsConfigsWatcher(),
    getIprsConfigRawWatcher(),
    publishIprsConfigWatcher(),
    createIprsConfigWatcher(),
    getGatewayConfigsWatcher(),
    getGatewayConfigRawWatcher(),
    publishGatewayConfigWatcher(),
    createGatewayConfigWatcher(),
    getSupportedParametersRequestWatcher(),
    stopBlastRequestWatcher(),
    getBatchProgressRequestWatcher(),
    sendRecurringPaymentRecommendationSmsRequestWatcher(),
    addRemittancesRequestWatcher(),
    cashBackRequestWatcher(),
    markAsPaidRequestWatcher(),
    markAsUnpaidRequestWatcher(),
    uploadLoyaltyDataRequestWatcher(),
    mapColumnsToFieldsRequestWatcher(),
    getPreviousLoyaltyStatusRequestWatcher(),
    getPreviousLoyaltiesStatusRequestWatcher(),
    createPremiumRequestWatcher(),
    hardDeletePremiumRequestWatcher(),
    createBenefitRequestWatcher(),
    hardDeleteBenefitRequestWatcher(),
    editProductRequestWatcher(),
    editPremiumRequestWatcher(),
    editBenefitRequestWatcher(),
    getPartnerConfigsRequestWatcher(),
    getPartnerEmailConfigsRequestWatcher(),
    getEmailClientsWatcher(),
    getPartnerConfigsClaimRequestWatcher(),
    getPartnerConfigsGroupRequestWatcher(),
    updatePartnerConfigGroupRequestWatcher(),
    updatePartnerConfigRequestWatcher(),
    updatePartnerConfigEmailRequestWatcher(),
    updatePartnerConfigClaimRequestWatcher(),
    updatePartnerRequestWatcher(),
    getPartnerSmsChannelsWatcher(),
    saveSmsChannelWatcher(),
    deleteSmsChannelWatcher(),
    testSmsChannelWatcher(),
    saveChannelResolutionWatcher(),
    getPolicyMakerChecksWatcher(),
    savePolicyMakerCheckWatcher(),
    deletePolicyMakerCheckWatcher(),
    logoutRequestWatcher(),
    getGroupProductConfigsRequestWatcher(),
    updateGroupProductConfigsRequestWatcher(),
    addGroupProductConfigsRequestWatcher(),
    getCustomerDependantsRequestWatcher(),
    getCustomerDependantRequestWatcher(),
    addCustomerDependantRequestWatcher(),
    updateCustomerDependantRequestWatcher(),
    deleteCustomerDependantRequestWatcher(),
    getCustomerDocumentsRequestWatcher(),
    getCustomerDocumentRequestWatcher(),
    addCustomerDocumentRequestWatcher(),
    updateCustomerDocumentRequestWatcher(),
    deleteCustomerDocumentRequestWatcher(),
    // getAllBanksWatcher(),
    createDebitOrderzRequestWatcher(),
    hardDeleteDebitOrderzRequestWatcher(),
    editDebitOrderzRequestWatcher(),
    getDebitOrderzRequestWatcher(),
    getBanksWatcher(),
    getUserRequestWatcher(),
    getAllPoliciesWatcher(),
    getAllPremiumsWatcher(),
    getAllPaymentsWatcher(),
    getAllProductsWatcher(),
    getAllCustomerClaimsWatcher(),
    getClosedClaimCallbackRequestWatcher(),
    getExtendedFamilyProductConfigsRequestWatcher(),
    updateExtendedFamilyProductConfigsRequestWatcher(),
    addExtendedFamilyProductConfigsRequestWatcher(),
    getPremiumConfigsRequestWatcher(),
    createPremiumConfigRequestWatcher(),
    createAddonConfigRequestWatcher(),
    getTotalPayablePremiumWatcher(),
    getAllMandatesWatcher(),
    getCustomeBeneficiaryRequestWatcher(),
    addCustomerBeneficiaryRequestWatcher(),
    updateCustomerBeneficiaryRequestWatcher(),
    deleteCustomerBeneficiaryRequestWatcher(),
    getCustomeBeneficiaryBankDetailsRequestWatcher(),
    addCustomerBeneficiaryBankDetailsRequestWatcher(),
    updateCustomerBeneficiaryBankDetailsRequestWatcher(),
    deleteCustomerBeneficiaryBankDetailsRequestWatcher(),
    getCustomerBankDetailsRequestWatcher(),
    updateCustomerBankDetailsRequestWatcher(),
    addCustomerBankDetailsRequestWatcher(),
    deleteCustomerBankDetailsRequestWatcher(),
    createQuoteRequestWatcher(),
    changeQuoteRequestWatcher(),
    BuyPolicyRequestWatcher(),
    getCustomerPoliciesRequestWatcher(),
    cancelPolicyRequestWatcher(),
    getCustomerQuotesRequestWatcher(),
    getCustomerPremiumsComplexRequestWatcher(),
    getStartedMessageRequestWatcher(),
    selectPolicyRequestWatcher(),
    downloadDocumentRequestWatcher(),
    emailDocumentRequestWatcher(),
    getTemplateDocumentRequestWatcher(),
    addTemplateDocumentRequestWatcher(),
    deleteTemplateDocumentRequestWatcher(),
    editTemplateDocumentRequestWatcher(),
    initiateClaimDcpRequestWatcher(),
    getCustomerClaimsDcpRequestWatcher(),
    getClaimsDcpRequestWatcher(),
    getClaimsDcpFilteredRequestWatcher(),
    createExpenseRequestWatcher(),
    deleteExpenseRequestWatcher(),
    editExpenseRequestWatcher(),
    addClaimDocumentRequestWatcher(),
    assignLawyerRequestWatcher(),
    markInvoiceAsPaidRequestWatcher(),
    deleteClaimDocumentRequestWatcher(),
    claimActionsRequestWatcher(),
    claimNotesRequestWatcher(),
    claimFacilityNotesRequestWatcher(),
    getClaimProcessingDcpRequestWatcher(),
    saveClaimDcpDocumentRequestWatcher(),
    PolicyNotesRequestWatcher(),
    PolicyNotesAddRequestWatcher(),
    createLOURequestWatcher(),
    editLOURequestWatcher(),
    getLOUSRequestWatcher(),
    createHospitalRequestWatcher(),
    deleteHospitalRequestWatcher(),
    getHospitalsRequestWatcher(),
    searchHospitalsRequestWatcher(),
    createDiagnosisRequestWatcher(),
    deleteDiagnosisRequestWatcher(),
    getDiagnosisRequestWatcher(),
    searchDiagnosisRequestWatcher(),
    bulkApproveRequestWatcher(),
    addBulkPolicyOnboardingRequestWatcher(),
    saveBulkPolicyOnboardingRequestWatcher(),
    getBulkPoliciesOnboardingBatchesRequestWatcher(),
    getFailedBulkPoliciesBatchesRequestWatcher(),
    getPreauthDetailsRequestWatcher(),
    deleteLouRequestWatcher(),
    getBulkPaymentsBatchesRequestWatcher(),
    addBulkPaymentsRequestWatcher(),
    saveBulkPaymentsRequestWatcher(),
    getFailedBulkPaymentsBatchesRequestWatcher(),
    claimCreateRequestWatcher(),
    getFeatureFlagsRequestWatcher(),
    getLookupListTypesRequestWatcher(),
    getLookupListRequestWatcher(),
    addLookupListItemRequestWatcher(),
    updateLookupListItemRequestWatcher(),
    deleteLookupListItemRequestWatcher(),
    registerAccessBankRequestWatcher(),
    updateAccessBankCustomerRequestWatcher(),
    UploadPolicyDocumentRequestWatcher(),
    createDebitOrdersDcpRequestWatcher(),
    getPoliciesDcpRequestWatcher(),
    getPolicyProcessingDcpRequestWatcher(),
    getPolicyProcessingCustomerQuotesRequestWatcher(),
    policyActionsRequestWatcher(),
    policyRejectActionsRequestWatcher(),
    makerCheckDecisionRequestWatcher(),
    returnToPriorStageRequestWatcher(),
    setNeedActionRequestWatcher(),
    quotationDecisionRequestWatcher(),
    addPolicyNotesAddRequestWatcher(),
    getPaymentsDcpRequestWatcher(),
    getPaymentProcessingDcpRequestWatcher(),
    paymentApproveActionRequestWatcher(),
    paymentRejectActionsRequestWatcher(),
    cancelPolicyActionRequestWatcher(),
    getAccessBankCustomerQuotesRequestWatcher(),
    getAccessBankCustomerPremiumsRequestWatcher(),
    removeComplexPremiumRequestWatcher(),
    getCustomerAccessBankClaimsRequestWatcher(),
    getAccessBankSmsActivitiesRequestWatcher(),
    deleteCustomerPolicyDocumentRequestWatcher(),
    getEmailTemplatesRequestWatcher(),
    addEmailTemplateRequestWatcher(),
    updateEmailTemplateRequestWatcher(),
    deleteEmailTemplateRequestWatcher(),
    addReportTemplateRequestWatcher(),
    getReportsTemplatesRequestWatcher(),
    generateReportRequestWatcher(),
    editReportTemplateRequestWatcher(),
    deleteReportTemplateRequestWatcher(),
    amendQuoteRequestWatcher(),
    getPaymentsByPolicyGuidRequestWatcher(),
    initiatePaymentWatcher(),
    generatePolicyCheckoutLinkWatcher(),
    findCustomerForTransferRequestWatcher(),
    switchPolicyCustomerRequestWatcher(),
    getGuideRequestWatcher(),
    getGuidesRequestWatcher(),
    addGuideRequestWatcher(),
    editGuideRequestWatcher(),
    deleteGuideRequestWatcher(),
    getElasticSearchResultsRequestWatcher(),
    NGSGroupCustomerQuotesRequestWatcher(),
    getNgsCustomerClaimsRequestWatcher(),
    getAuditsRequestWatcher(),
    getEmailTemplateByGuidRequestWatcher(),
    sendEmailRequestWatcher(),
    registerDcpRequestWatcher(),
    updateDcpCustomerRequestWatcher(),
    getRecentPoliciesRequestWatcher(),
    getRecentPaymentsRequestWatcher(),
    createProductPackageRequestWatcher(),
    getProductPackagesRequestWatcher(),
    updateProductPackageRequestWatcher(),
    deleteProductPackageRequestWatcher(),
    getProductPackageBenefitsRequestWatcher(),
    createProductPackageBenefitRequestWatcher(),
    createBenefitRatingChainRequestWatcher(),
    updateBenefitRatingChainRequestWatcher(),
    updateProductPackageBenefitRequestWatcher(),
    deleteProductPackageBenefitRequestWatcher(),
    getUserAuthActivitiesRequestWatcher(),
    getDisabledUsersRequestWatcher(),
    getAllUsersAuthActivitiesRequestWatcher(),
    enableUserRequestWatcher(),
    getProductAddonsRequestWatcher(),
    updateProductAddonRequestWatcher(),
    deleteProductAddonRequestWatcher(),
    createProductAddonRequestWatcher(),
    getCashbackConfigRequestWatcher(),
    createCashbackConfigRequestWatcher(),
    updateCashbackConfigRequestWatcher(),
    deleteCashbackConfigRequestWatcher(),
    createAgeValidationRuleRequestWatcher(),
    updateAgeValidationRuleRequestWatcher(),
    deleteAgeValidationRuleRequestWatcher(),
    getAgeValidationRulesRequestWatcher(),
    deleteProductAutoRenewalConfigRequestWatcher(),
    updateProductAutoRenewalConfigRequestWatcher(),
    createProductAutoRenewalConfigRequestWatcher(),
    getProductAutoRenewalConfigRequestWatcher(),
    uploadDocumentRequestWatcher(),
    pollDraftJobRequestWatcher(),
    fetchPartnerDraftsRequestWatcher(),
    reviewDraftRequestWatcher(),
    importDraftProductRequestWatcher(),
    evaluateProductQuoteRequestWatcher(),
    compareQuotationsRequestWatcher(),
    getProductRatingNodesRequestWatcher(),
    createProductRatingNodeRequestWatcher(),
    updateProductRatingNodeRequestWatcher(),
    deleteProductRatingNodeRequestWatcher(),
    getRatingTablesRequestWatcher(),
    ratingTableActionRequestWatcher(),
    saveRatingTableRequestWatcher(),
    downloadRatingTemplateRequestWatcher(),
    validateRatingWorkbookRequestWatcher(),
    importRatingWorkbookRequestWatcher(),
    getRatingSnapshotsRequestWatcher(),
    getChangeRequestsRequestWatcher(),
    resolveChangeRequestRequestWatcher(),
    createClaimNotesRequestWatcher(),
    deleteClaimNotesRequestWatcher(),
    updateClaimNotesRequestWatcher(),
    getPolicyByGuidRequestWatcher(),
    otpVerifyRequestWatcher(),
    otpResendRequestWatcher(),
    getPolicyCancellationRequestsWatcher(),
    updatePolicyCancellationWatcher(),
    getAllWebhookSubscriptionsRequestWatcher(),
    createWebhookSubscriptionRequestWatcher(),
    editWebhookSubscriptionRequestWatcher(),
    deleteWebhookSubscriptionRequestWatcher(),
    saveWebhookSubscriptionAuthRequestWatcher(),
    deleteWebhookSubscriptionAuthRequestWatcher(),
    getOrganizationsRequestWatcher(),
    getOrganizationRequestWatcher(),
    createOrganizationRequestWatcher(),
    updateOrganizationRequestWatcher(),
    deleteOrganizationRequestWatcher(),
    getOrgProductTemplatesRequestWatcher(),
    createOrgProductTemplateRequestWatcher(),
    updateOrgProductTemplateRequestWatcher(),
    deleteOrgProductTemplateRequestWatcher(),
    getOrgEmailTemplatesRequestWatcher(),
    createOrgEmailTemplateRequestWatcher(),
    updateOrgEmailTemplateRequestWatcher(),
    deleteOrgEmailTemplateRequestWatcher(),
    getOrgSmsTemplatesRequestWatcher(),
    createOrgSmsTemplateRequestWatcher(),
    updateOrgSmsTemplateRequestWatcher(),
    deleteOrgSmsTemplateRequestWatcher(),
    getOrgWebhookTemplatesRequestWatcher(),
    createOrgWebhookTemplateRequestWatcher(),
    updateOrgWebhookTemplateRequestWatcher(),
    deleteOrgWebhookTemplateRequestWatcher(),
    loadOrgConfigOnPartnerSwitchWatcher(),
    loadOrgConfigRequestWatcher(),
    getOrgIppConfigsRequestWatcher(),
    createOrgIppConfigRequestWatcher(),
    updateOrgIppConfigRequestWatcher(),
    deleteOrgIppConfigRequestWatcher(),
    getOrgClaimInitConfigsRequestWatcher(),
    createOrgClaimInitConfigRequestWatcher(),
    updateOrgClaimInitConfigRequestWatcher(),
    deleteOrgClaimInitConfigRequestWatcher(),
    getOrgCustomerStatusConfigsRequestWatcher(),
    createOrgCustomerStatusConfigRequestWatcher(),
    updateOrgCustomerStatusConfigRequestWatcher(),
    deleteOrgCustomerStatusConfigRequestWatcher(),
    getOrgClaimProcConfigsRequestWatcher(),
    createOrgClaimProcConfigRequestWatcher(),
    updateOrgClaimProcConfigRequestWatcher(),
    deleteOrgClaimProcConfigRequestWatcher(),
    // Commission Service
    getCommissionAgentsRequestWatcher(),
    getCommissionAgentRequestWatcher(),
    resolveCommissionAgentsWatcher(),
    commissionAgentExistsWatcher(),
    lookupCommissionAgentRequestWatcher(),
    createCommissionAgentRequestWatcher(),
    createAgentWithUserWatcher(),
    updateCommissionAgentRequestWatcher(),
    deleteCommissionAgentRequestWatcher(),
    deleteCommissionAgentPermanentRequestWatcher(),
    getUsersForAgentsRequestWatcher(),
    getAgentBanksByAgentRequestWatcher(),
    createAgentBankRequestWatcher(),
    updateAgentBankRequestWatcher(),
    deleteAgentBankRequestWatcher(),
    deleteAgentBankPermanentRequestWatcher(),
    getCommissionAgenciesRequestWatcher(),
    getCommissionAgencyRequestWatcher(),
    createCommissionAgencyRequestWatcher(),
    updateCommissionAgencyRequestWatcher(),
    getCommissionRulesRequestWatcher(),
    getCommissionRuleRequestWatcher(),
    createCommissionRuleRequestWatcher(),
    updateCommissionRuleRequestWatcher(),
    validateCommissionRuleRequestWatcher(),
    getClawbackRulesRequestWatcher(),
    getClawbackRuleRequestWatcher(),
    createClawbackRuleRequestWatcher(),
    updateClawbackRuleRequestWatcher(),
    validateClawbackRuleRequestWatcher(),
    getClawbackSymbolsRequestWatcher(),
    getCommissionTransactionsRequestWatcher(),
    getPayoutTransactionsRequestWatcher(),
    getClawbackTransactionsRequestWatcher(),
    getCommissionTxnStatsRequestWatcher(),
    getPayoutTxnStatsRequestWatcher(),
    getClawbackTxnStatsRequestWatcher(),
    getCommissionTransactionByGuidRequestWatcher(),
    getCommissionTransactionsByAgentRequestWatcher(),
    getCommissionStatementRequestWatcher(),
    getPayoutTransactionByGuidRequestWatcher(),
    getPayoutTransactionsByAgentRequestWatcher(),
    getClawbackTransactionByGuidRequestWatcher(),
    getClawbackTransactionsByAgentRequestWatcher(),
    getCommissionCalculationLogRequestWatcher(),
    getCommissionAccountsRequestWatcher(),
    getAgentCommissionAccountRequestWatcher(),
    getCommissionAccountByGuidRequestWatcher(),
    getAgentCommissionAccountTransactionsRequestWatcher(),
    getBatchPayoutsRequestWatcher(),
    getBatchPayoutRequestWatcher(),
    createBatchPayoutRequestWatcher(),
    payBatchPayoutsRequestWatcher(),
    confirmBatchPayoutRequestWatcher(),
    batchPayoutPollingWatcher(),
    getAgencyAgentsRequestWatcher(),
    resolveHeldBatchPayoutsWatcher(),
    getCommissionSettingsRequestWatcher(),
    updateCommissionSettingsRequestWatcher(),
    getOmkGroupsRequestWatcher(),
    getOmkGroupRequestWatcher(),
    approveOmkGroupRequestWatcher(),
    setOmkGroupVerificationRequestWatcher(),
    uploadOmkGroupDocumentRequestWatcher(),
    deleteOmkGroupDocumentRequestWatcher(),
    getOmkGroupPoliciesRequestWatcher(),
    approveOmkGroupPoliciesRequestWatcher(),
    getGroupPaymentsRequestWatcher(),
    getGroupPaymentRequestWatcher(),
    updateGroupPaymentStatusRequestWatcher(),
    resolveOmkPaymentLabelsRequestWatcher()
  ]
}
